module.exports = __webpack_public_path__ + "static/media/img-0d7c9b12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/pwell-logo.png
// module id = 5300
// module chunks = 39